<template>
  <div class="order-price">
    {{ $t('Precio') }}:
    <router-link :to="createOrderPriceLink('-')"
      :class="[ queryOrder ==  'precio-' ? 'active' : '']"><i class="fa fa-caret-down order-ico-size"></i></router-link>
    <span>|</span>
    <router-link :to="createOrderPriceLink('+')"
      :class="[ queryOrder ==  'precio+' ? 'active' : '']"><i class="fa fa-caret-up order-ico-size"></i></router-link>
  </div>
</template>

<i18n>
{
  "es": {
    "Precio": "Precio"
  },
  "en": {
    "Precio": "Price"  
  },
  "ca": {
    "Precio": "Preu"
  }
}
</i18n>

<script>
  import { mapGetters } from 'vuex';

	export default {
		data: () => {
			return{
        order: 'precio+'
			}
		},
    computed:{
      ...mapGetters({ query: 'getQuery' }),
      queryOrder: function(){
        var tmp = Object.assign({}, this.query);
        return tmp.orden;
      }
    },
    methods: {
      createOrderPriceLink(option){
        var tmp = Object.assign({}, this.query);
        return ( { query: Object.assign(tmp, { orden: 'precio'+option }) } );
      }
    },
    watch: {
      /*resultsPerPage: function() { 
        this.resultsPerPage = this.getResultsPerPage;
      }*/
    }
  }
</script>
